<template>
    <data-dialog 
        :dialog-title="lsDialog.title" 
        :is-visible="lsDialog.lsFormVisible" 
        :is-read="isRead"
        @dgVerifyDeal="dgVerifyDeal2('lsDialog','lsForm')" 
        ref="lsDialog" 
        @dgConfirmDeal="dgLsConfirmDeal"
        @dgCancelDeal="dgCancelDeal"
    >
        <div slot="dialogFrom">
            <el-form ref="lsForm" :model="lsDialog.data" :rules="lsRules" label-width="100px" :disabled="isRead"
                    label-position="top" class="commonForm">
                <el-row>
                <el-col :span="12">
                    <el-form-item label="水位" prop="rz" style="width: 70%;">
                    <el-input v-model="lsDialog.data['rz']" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="流量" prop="q" style="width: 70%;">
                    <el-input v-model="lsDialog.data['q']" clearable></el-input>
                    </el-form-item>
                </el-col>
                </el-row>
            </el-form>
        </div>
    </data-dialog>
</template>
<script>
import DataDialog from "@/components/tableGather/dataDialog";
export default {
    components: {
        DataDialog,
    },
    props:{
        lsDialog:{
            type:Object
        },
        isRead:{
            type:Boolean
        },
        isAddLs:{
            type:Boolean
        },
    },
    data() {
        let validateRealNum = (rule, value, callback) => {
            if (value == null || value.length == 0) {
                callback();
            } else {
                let reg = /^[-+]?[0-9]*\.?[0-9]+$/;
                if (reg.test(value)) {
                    let zs = (value + '').split('.')[0];
                    if (zs.length > 6) {
                        return callback(new Error("该数据最多6位"));
                    }
                    callback();
                } else {
                    return callback(new Error("只能输入数值"));
                }
            }
        };
        return {
            loading:false,
            lsRules: {
                rz: [
                    {required: true, message: "请输入水位", trigger: 'blur'},
                    {validator: validateRealNum, trigger: 'blur'},
                ],
                q: [
                    {required: true, message: "请输入流量", trigger: 'blur'},
                    {validator: validateRealNum, trigger: 'blur'},
                ],
            },
        };
    },
    methods:{
        dgVerifyDeal2(dgRef, frRef) {
            this.$refs[frRef].validate((valid) => {
                if (valid) {
                this.$refs[dgRef].isShowPop(true);
                } else {
                this.$refs[dgRef].isShowPop(false);
                }
            });
        },
        dgCancelDeal() {
            if (this.lsDialog.lsFormVisible) {
                this.lsDialog.lsFormVisible = false;
                this.$refs.lsForm.resetFields();
                this.$refs.lsForm.clearValidate();
            }
        },
        dgLsConfirmDeal() {
            if (this.isAddLs) {
                this.addLsData();
            } else {
                this.updateLsData();
            }
        },
        updateLsData() {
            this.request.post('/rm-brcurve/v1/modifyRcurve', this.lsDialog.data).then(res => {
                if (res.ok) {
                    this.$message.success('修改流量水位数据成功');
                    this.params = {
                        total: 0,
                        size: 10,
                        current: 1,
                    };
                    this.isAddLs = false;
                    this.lsDialog.lsFormVisible = false;
                    this.getLsQxData();
                    this.getLsChartData();
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
    },
}
</script>

<style scoped>
::v-deep .el-dialog {
    margin: 0 auto;
    overflow: hidden !important;
    height: 70% !important;
    width: 50% !important;
}
::v-deep .el-dialog__header {
    display: block !important;
    height: 6vh;
    line-height: 6vh;
    padding: 0;
    background-color: #F0EFEF;
    position: relative;
}
::v-deep .el-dialog__footer {
    display: block !important;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
}

::v-deep .el-dialog__headerbtn {
    position: absolute;
    top: 0px;
    right: 10px;
    height: 5vh;
    line-height: 5vh;
}

::v-deep .el-dialog__body {
    padding: 10px 20px 0px 20px !important;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    position: absolute;
    left: 0;
    top: 6vh;
    bottom: 70px;
    right: 0;
    overflow: auto;
}

::v-deep .dialog-footer {
    display: flex !important;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #fff;
    width: 100%;
    height: 70px;
    z-index: 10;
    justify-content: flex-end;
    align-items: Center;
    box-sizing: border-box;
    padding-right: 20px;
}
</style>
